export default __webpack_public_path__ + "static/media/036-raccoon.844bc6b7.svg";